import { useBlockNoteEditor } from "@blocknote/react";
import { AIExtension, AIMenu, getDefaultAIMenuItems } from "@blocknote/xl-ai";
import React from "react";
import { SCRIPT_TEXT_FORMAT } from "./scriptPrompt";

const REVIEW_KEYS = new Set(["accept", "revert", "retry", "cancel"]);

export function ReviseAIMenu() {
  const editor = useBlockNoteEditor();

  return (
    <AIMenu
      onManualPromptSubmit={(userPrompt) => {
        const ai = editor.getExtension(AIExtension);
        if (!ai) return;
        void ai.invokeAI({
          userPrompt: `${userPrompt}\n\n${SCRIPT_TEXT_FORMAT}`,
          useSelection: editor.getSelection() !== undefined,
        });
      }}
      items={(editor, status) => {
        if (status === "user-input") return [];
        return getDefaultAIMenuItems(editor, status).filter((item) =>
          REVIEW_KEYS.has(item.key)
        );
      }}
    />
  );
}
